import { useState } from 'react';
import apiClient from '../../../services/apiClientService';
import { Routes } from '../../../routes/RouteConstants';
import useErrorHandler, { isCouponRejected } from '../../../hooks/useErrorHandler';
import { useTenant } from '../../../contexts/TenantContext';

/**
 * What a coupon would do to the chosen supply's price, for the signed-in guest. Tied to the supply,
 * not to the pre-reservation, which the page renews on "Véglegesítés" (DECISIONS.md D26). Not
 * binding: the confirmation checks the coupon again.
 *
 * A rejected coupon comes back as `errorMessage`, for the field to show under itself; that is the
 * one exception to routing every failure through useErrorHandler. Anything else (a 401, a network
 * error) still goes there.
 */
const useCheckCoupon = () => {
  const { tenantId } = useTenant();
  const [loading, setLoading] = useState(false);
  const { handleError } = useErrorHandler();

  const checkCoupon = async (couponCode, supplyId) => {
    setLoading(true);

    try {
      const response = await apiClient.post(`/v1/tenants/${tenantId}/coupons/check`, { couponCode, supplyId });
      return { coupon: response.data };
    } catch (error) {
      if (isCouponRejected(error)) {
        return { errorMessage: error.response.data.message };
      }
      handleError(error, Routes.CONFIRM_BOOKING);
      return {};
    } finally {
      setLoading(false);
    }
  };

  return { checkCoupon, loading };
};

export default useCheckCoupon;
